import { PITCH_UP_THRESHOLD } from '../constants';
import type { FrameResult } from '../types';
import { BaseChallenge } from './base-challenge';

export class PitchUpChallenge extends BaseChallenge {
  constructor() {
    super('pitch_up');
  }

  processFrame(frame: FrameResult): void {
    if (!frame.headPose) {
      return;
    }

    this.captureFrame();

    const { pitch } = frame.headPose;

    const progress = Math.max(
      Math.min((PITCH_UP_THRESHOLD - pitch) / PITCH_UP_THRESHOLD, 1),
      0,
    );
    this.reportProgress(progress);

    if (pitch < PITCH_UP_THRESHOLD) {
      this.pass(0.9);
    }
  }
}
